import React from 'react';
import { DatePicker as MDatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';

export const DatePicker = props => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MDatePicker inputFormat="MM/DD/YYYY" {...props} value={typeof props.value === 'string' ? moment(props.value) : props.value} />
    </LocalizationProvider>
  )
}